import { required, maxLength } from "vuelidate/lib/validators";

export default {
  validations: {
    zoneForm: {
      name: {
        required,
        maxLength: maxLength(255),
      },
      description: {
        maxLength: maxLength(500),
      },
    },
  },
  computed: {
    zoneNameError() {
      const errors = [];
      if (!this.$v.zoneForm.name.$dirty) return errors;
      if (!this.$v.zoneForm.name.required)
        errors.push(this.$t("field_required"));
      if (!this.$v.zoneForm.name.maxLength)
        errors.push(this.$t("max_length_255"));
      return errors;
    },
  },
};
